<div class="side-by-side-tabs position-relative">
    <div class="panel-title border-0 mb-3">
        {{isTagForm? 'Tag' : 'Untag'}} Monotainer
    </div>
    <button type="button" class="close" aria-label="Close" title="Close" (click)="closeDialogue()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div [formGroup]="tagMonotainerForm" *ngIf="isTagForm">

        <div class="bg-light-grey p-4">
            <div *ngIf="data?.msg === 'map'">
                <div class="d-flex mb-3">
                    <div class="device-font-class mb-2">
                        <div class="cnp-popup-value-headers mb-2">Monotainer ID :</div>
                        <span class="values-rendered">{{data?.taggedDetails?.entityId}}</span>
                    </div>
                </div>
            </div>
            <div class="d-flex mb-3">
                <mat-form-field>
                    <mat-label class="cnp-popup-value-headers">Select Destination</mat-label>
                    <mat-select [disableOptionCentering]="true" formControlName="destination">
                        <mat-option class="text-capitalize" *ngFor="let option of destinationList" [value]="option.key"
                            selected (click)="onDestinationChange()">
                            <!-- {{option.name | titlecase}} -->
                            {{option.name}}
                        </mat-option>
                    </mat-select>
                    <ng-container *ngIf="userSubmit && tagMonotainerFormValues['destination']?.errors">
                        <mat-error *ngIf="tagMonotainerFormValues['destination']?.errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Destination is required
                        </mat-error>
                    </ng-container>
                </mat-form-field>
            </div>
            <div>
                <div> Available Lanes:</div>
                <div class="lane-display" *ngIf="laneDetails?.length && showLanes">
                    <div *ngFor="let lane of laneDetails">
                        <div class="d-flex lane-availability"
                            [style.border-color]="colorAvailabliltyCheck(lane.availability)"
                            [style.color]="colorAvailabliltyCheck(lane.availability)">
                            {{lane?.name}}<br><span class="available-label">{{lane.availability}}% Available</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="!laneDetails?.length">No Lanes Available</div>

            </div>
        </div>
    </div>
    <div class="untag-grey-container">
        <div class="d-grid mb-3 mt-3" *ngIf="!isTagForm">
            <div class="untagFont-a text-center mb-2">Are you sure you want to untag</div>
            <div class="untagFont-b  text-center mb-4" *ngIf="data?.msg === 'map'">{{data?.taggedDetails?.entityId}}
                from
                {{data?.taggedDetails?.destinationName}}</div>
        </div>
        <div class="btn-basket" *ngIf="isTagForm">
            <button mat-raised-button color="primary" *ngIf="!userSubmit" (click)="resetForm()">Clear</button>
            <button mat-raised-button color="primary" *ngIf="!userSubmit" (click)="submitForm('tag')"
                [disabled]="!laneDetails?.length || (data?.msg !== 'multitag' && data?.msg !== 'multiUntag' && data?.taggedDetails?.state !== 'init')">Tag</button>
            <button mat-raised-button color="primary" *ngIf="userSubmit" (click)="closeDialogue()">Close</button>
        </div>
        <div class="btn-basket" *ngIf="!isTagForm">
            <button mat-raised-button color="primary" *ngIf="!userSubmit" (click)="dialogRef.close()">No</button>
            <button mat-raised-button color="primary" (click)="submitForm('untag')" *ngIf="!userSubmit"
                [disabled]="!laneDetails?.length && data?.msg !== 'multitag' && data?.msg !== 'multiUntag'">Yes</button>
            <button mat-raised-button color="primary" *ngIf="userSubmit" (click)="closeDialogue()">Close</button>
        </div>
    </div>
    <div class="green-color" *ngIf="(data?.msg !== 'multitag' || data?.msg !== 'multiUntag') && successMessage?.length">
        Success: <span *ngFor="let entity of successMessage;let i=index">{{entity}}
            <span *ngIf="i<(successMessage?.length-1)">,</span>
        </span>
    </div>
    <div class="red-color" *ngIf="(data?.msg !== 'multitag' || data?.msg !== 'multiUntag') && errorMessage?.length">
        Error: <span *ngFor="let entity of errorMessage;let i=index">{{entity}}
            <span *ngIf="i<(errorMessage?.length-1)">,</span>
        </span>
    </div>
</div>